export default __webpack_public_path__ + "static/media/screenShots_astramed-1.be3fdd46.jpg";